var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 106,
    viewBox: "0 0 120 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_480_8412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.2151 13.0583L39.9318 13.6308C38.0765 17.3848 34.256 19.7601 30.075 19.7601H10.9991C4.92447 19.7594 0 24.6923 0 30.7775V71.2575C0 77.3427 4.92447 82.2756 10.9991 82.2756H80.2625C86.3372 82.2756 91.2616 77.3427 91.2616 71.2575V17.9478C91.2616 11.8627 86.3372 6.92969 80.2625 6.92969H50.0727C45.8909 6.92969 42.0711 9.30499 40.2158 13.059L40.2151 13.0583Z",
    fill: "#20B198"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.2423 86.2553L4.08057 79.8213H33.8781V86.2553H14.2423Z",
    fill: "#20B198"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.9523 0H87.379C90.0673 0 92.2507 2.18641 92.2507 4.88015V69.6581C92.2507 72.3511 90.0681 74.5383 87.379 74.5383H8.9523C6.26392 74.5383 4.08057 72.3519 4.08057 69.6581V4.88015C4.08057 2.18641 6.2632 0 8.9523 0Z",
    fill: "#D2E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M49.4983 18.8483L49.215 19.4208C47.3597 23.1748 43.5399 25.5501 39.3582 25.5501H20.2823C14.2077 25.5501 9.2832 30.4831 9.2832 36.5683V77.0483C9.2832 83.1334 14.2077 88.0664 20.2823 88.0664H89.5457C95.6204 88.0664 100.545 83.1334 100.545 77.0483V23.7379C100.545 17.6527 95.6204 12.7197 89.5457 12.7197H59.3559C55.1741 12.7197 51.3543 15.095 49.499 18.849L49.4983 18.8483Z",
    fill: "#32C7A0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M89.6627 105.383C106.417 105.383 120 91.7769 120 74.9932C120 58.2094 106.417 44.6035 89.6627 44.6035C72.9079 44.6035 59.3254 58.2094 59.3254 74.9932C59.3254 91.7769 72.9079 105.383 89.6627 105.383Z",
    fill: "#F6576A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M96.5928 74.993L104.614 66.9581C105.797 65.7727 105.797 63.8511 104.614 62.6664L101.968 60.0161C100.785 58.8306 98.8665 58.8306 97.6837 60.0161L89.6627 68.051L81.6416 60.0161C80.4582 58.8306 78.54 58.8306 77.3573 60.0161L74.7115 62.6664C73.5281 63.8519 73.5281 65.7734 74.7115 66.9581L82.7326 74.993L74.7115 83.028C73.5281 84.2134 73.5281 86.135 74.7115 87.3197L77.3573 89.97C78.5407 91.1555 80.4589 91.1555 81.6416 89.97L89.6627 81.9351L97.6837 89.97C98.8672 91.1555 100.785 91.1555 101.968 89.97L104.614 87.3197C105.797 86.1342 105.797 84.2127 104.614 83.028L96.5928 74.993Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_480_8412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 105.382,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoAccounts);
export default __webpack_public_path__ + "static/media/icon_no_accounts.ecc0efd6ab0b3cf82f01bfef3916ab42.svg";
export { ForwardRef as ReactComponent };